import type {
  StravaStatus,
  IntegrationsResponse,
  IntegrationRunsResponse,
} from "@atlas/shared";
import { apiPost, apiDelete, apiGet } from "../lib/api-client";

export type {
  StravaStatus,
  SyncRunStatus,
  SyncRunSummary,
  IntegrationProvider,
  IntegrationCurrentRun,
  IntegrationRow,
  IntegrationsResponse,
  IntegrationRunsResponse,
} from "@atlas/shared";

// ─── Hub ──────────────────────────────────────────────────────────────────────

export function fetchIntegrations(): Promise<IntegrationsResponse> {
  return apiGet("/integrations");
}

export function fetchIntegrationRuns(provider?: string): Promise<IntegrationRunsResponse> {
  const qs = provider ? `?provider=${encodeURIComponent(provider)}` : "";
  return apiGet(`/integrations/runs${qs}`);
}

// ─── Strava ───────────────────────────────────────────────────────────────────

export function fetchStravaStatus(): Promise<StravaStatus> {
  return apiGet("/integrations/strava/status");
}

export function triggerStravaSync(): Promise<{ ok: boolean; message: string }> {
  return apiPost("/integrations/strava/sync");
}

export function disconnectStrava(): Promise<{ ok: boolean }> {
  return apiDelete("/integrations/strava");
}
